import _reduce from 'lodash/reduce'
import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import Dashboard from '../../components/Dashboard'
import localize from '../../store/localize'
import strings from '../../components/Dashboard/Dashboard.json'
import { actionAppSetShowLoginState, actionAppSetAutoLaunchEnabledState } from '../../actions'

// Check if we have a user list available
// if one is available, count the entries
function getUserCount(users, server) {
    if (users.list == null || users.list[server] == null) return 0

    return _reduce(
        users.list[server],
        (r, v) => {
            if (v.shell === true) return r
            return r + 1
        },
        0,
    )
}

function mapStateToProps(state) {
    const { app, steam, users, servers } = state
    const userCount = getUserCount(users, servers.active)

    // Check whether we're doing a steam login regardless of users already being logged in
    const doSteamLogin =
        steam.steamStartup && !steam.hasLoggedIn && steam.steamTicket !== steam.usedTicket

    return {
        doSteamLogin,
        showLogin: app.showLogin,
        userCount,
        localize: value => localize(strings, selectors.getLanguage(state), value),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setLoginShowState: (showLogin) => {
            dispatch(actionAppSetShowLoginState(showLogin))
        },
        disableAutoRun: () => {
            dispatch(actionAppSetAutoLaunchEnabledState(false))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js